/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Ujjwal Singh >

*/

import React from "react";
import { Link as RouterLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { AppBar, Toolbar, Button } from "@material-ui/core";
import AdvenioLogo from "images/advenio-logo.png";

//action
import { updateLoginModel } from "actions/global-action";
const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow:
      "0 0px 0px 0 rgba(0, 0, 0, 0.2), 0 4px 4px 0 rgba(0, 0, 0, 0.19)",
  },
  Toolbar: {
    background: "#fff",
  },
  flexGrow: {
    flexGrow: 1,
    textAlign: "end",
  },
  signInBtnContainer: {
    padding: "0 85px",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      padding: "0px",
      textAlign: "center",
    },
  },
  logoContainer: {
    display: "flex",
    // borderRight:'1px solid #dddddd',
    padding: "0 10px",
    [theme.breakpoints.down("md")]: {
      marginLeft: "75px",
    },
  },
  tradeMark: {
    fontSize: "9px",
    verticalAlign: "top",
  },
}));

const Topbar = (props) => {
  const { className, ...rest } = props;

  const classes = useStyles();
  const handleSlide = () => {
    props.updateLoginModel(!props.globalStore.isLoginPopUpModel);
  };

  return (
    <AppBar
      {...rest}
      className={clsx(classes.root, className)}
      color="primary"
      position="fixed"
      id="topBar-main"
    >
      <Toolbar className={classes.Toolbar}>
        <div style={{ display: "flex" }}>
          <RouterLink to="/">
            <div className={classes.logoContainer}>
              {/* <img alt="Logo" src={AdvenioTel} width="200" /> */}
              <img alt="Logo" src={AdvenioLogo} width="200" />
              <a className={classes.tradeMark}>
                <b>TM</b>
              </a>
            </div>
          </RouterLink>
          {/* <h2 style={{color:'#000',margin:'10px'}}>Telemedicine</h2> */}
          {/* <img
            alt="Logo"
            src={AdvenioTel}
            width="120"
            height='30'
            style={{margin:'10px'}}
          /> */}
        </div>
        <div className={classes.flexGrow}>
          {/* We don't need Sign in button now to initiate the slide, since slide itself is disabled. This is for persistant login box. Author: Sai */}
          {/* <span className={classes.signInBtnContainer}>
            <Button
              className={classes.signOutButton}
              color="secondary"
              onClick={handleSlide}
            >
              Sign In
            </Button>
          </span> */}
        </div>
      </Toolbar>
    </AppBar>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
};

function mapStateToProps(store) {
  return {
    globalStore: store.globalStore,
  };
}
export default connect(mapStateToProps, { updateLoginModel })(
  withRouter(Topbar)
);
